/**
 * Formats a Date object or date string to 'dd/MM/yyyy'.
 * @param {Date|string} dateInput
 * @returns {string} Formatted date string.
 */
export function formatDateToDDMMYYYY(dateInput) {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(date)) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

/**
 * Formats a Date object or date string to 'd MMMM yyyy' (e.g., '31 May 2025').
 * @param {Date|string} dateInput
 * @returns {string} Formatted date string.
 */
export function formatDateToWrittenDate(dateInput) {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(date)) return '';

    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
}